import { LoggerService } from '../../common/common.module'

import { SupplierService, SUPPLIER_SERVICE_NAME } from '../../../services/supplier'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { SupplierCreateEditController } from './supplier-create-edit.directive.controller'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'

// #region Consts

import * as TEMPLATE from './supplier-create-edit.tpl.html'

// #endregion


// #region Setup

export class SupplierCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'logger', USER_SESSION_SERVICE_NAME, SUPPLIER_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        userSessionService: UserSessionService,
        supplierService: SupplierService
    ) => new SupplierCreateEditController(
        $scope,
        $q,
        $timeout,
        logger,
        userSessionService,
        supplierService,
        SupplierService.REFERENCE_TYPE,
        SupplierService.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// #endregion